export const TournamentMoneyType = {
  PgCoin: 0,
  FreeBet: 1,
  RealMoney: 2,
};
